import { DATE_OPTIONS, getDateFromNow } from "../../core/utils/date-utils";
import { RE_ASSESSMENT_DATE_TYPE } from "./re-assessment-filter-query";

/**
 * Yeniden değerlendirme ekranının açılış filtresi — sol panel (ReAssessmentFilter) ve hızlı filtre çubuğunun
 * "Sıfırla"sı ortak kullanır; ikisi ayrı yazılırsa Sıfırla paneldekinden farklı bir başlangıca döner.
 * Tarihler HAM (moment); UTC/yerel dönüşümü re-assessment-filter-query'de.
 */
export const buildDefaultReAssessmentFilter = () => {
    const date = getDateFromNow(DATE_OPTIONS.LAST_15_DAYS);

    return {
        dateType: RE_ASSESSMENT_DATE_TYPE.REQUEST,
        dateBegin: date.start,
        dateEnd: date.end,
        hospitalIdList: [],
    }
}
